"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.win = void 0;
// Jest with JSDOM doesn't allow to override some win props, e.g. win.top, win.parent
// To be able to test different scenarios (multiple frames on the page, current frame is not top) need to proxy
// win object via this module, so it will be possible to mock it in test environment
exports.win = typeof window !== 'undefined' ? window : undefined;
//# sourceMappingURL=index.js.map